import { apiFetch } from "../api.js";
import type {
  CreateFamilyMemberInput,
  FamilyMember,
  FamilyMembersListResponse,
  UpdateFamilyMemberInput,
} from "./types.js";

/**
 * Family members API module — Phase 5 Session 1.
 *
 * Soft-delete via PATCH `is_archived: true` or DELETE (idempotent).
 */

export function listFamilyMembers(
  includeArchived = false,
): Promise<FamilyMembersListResponse> {
  const qs = includeArchived ? "?include_archived=true" : "";
  return apiFetch<FamilyMembersListResponse>(`/v1/family-members${qs}`);
}

export function getFamilyMember(memberId: string): Promise<FamilyMember> {
  return apiFetch<FamilyMember>(`/v1/family-members/${memberId}`);
}

export function createFamilyMember(
  input: CreateFamilyMemberInput,
): Promise<FamilyMember> {
  return apiFetch<FamilyMember>("/v1/family-members", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateFamilyMember(
  memberId: string,
  input: UpdateFamilyMemberInput,
): Promise<FamilyMember> {
  return apiFetch<FamilyMember>(`/v1/family-members/${memberId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteFamilyMember(memberId: string): Promise<void> {
  return apiFetch<void>(`/v1/family-members/${memberId}`, { method: "DELETE" });
}
